import { useLanguage } from '../contexts/LanguageContext';
import enTranslations from '../locales/en.json';
import noTranslations from '../locales/no.json';

const translations = {
  en: enTranslations,
  no: noTranslations,
};

export const useTranslation = () => {
  const { language, setLanguage } = useLanguage();

  const t = (key, variables = {}, fallback = '') => {
    const keys = key.split('.');
    let translation = translations[language];
    
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // Fallback to English if translation not found
        translation = translations.en;
        for (const fallbackKey of keys) {
          if (translation && translation[fallbackKey]) {
            translation = translation[fallbackKey];
          } else {
            return fallback || key;
          }
        }
        break;
      }
    }
    
    if (typeof translation === 'string') {
      // Replace variables in the translation string
      let result = translation;
      Object.keys(variables).forEach(variable => {
        const regex = new RegExp(`{${variable}}`, 'g');
        result = result.replace(regex, variables[variable]);
      });
      return result;
    }
    
    return fallback || key;
  };

  return { t, language, setLanguage };
};
